var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlayButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 31,
    viewBox: "0 0 38 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.56641 30.7949H32.4336C35.5028 30.7949 38 28.2067 38 25.0257V6.56415C38 3.38315 35.5028 0.794922 32.4336 0.794922H5.56641C2.49724 0.794922 0 3.38315 0 6.56415V25.0257C0 28.2067 2.49724 30.7949 5.56641 30.7949ZM14.5469 10.0257C14.5469 9.60654 14.7665 9.22 15.1209 9.01608C15.471 8.81323 15.9069 8.82338 16.2505 9.04761L25.1567 14.8168C25.4818 15.0275 25.6797 15.3972 25.6797 15.7949C25.6797 16.1927 25.4818 16.5623 25.1567 16.773L16.2505 22.5422C16.07 22.6594 15.8657 22.718 15.6602 22.718C15.4742 22.718 15.2883 22.6695 15.1209 22.5738C14.7665 22.3698 14.5469 21.9833 14.5469 21.5642V10.0257Z",
    fill: "#2D2D2D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayButton);
export default __webpack_public_path__ + "static/media/PlayButton.4dffacd20e394962ca370dbbe17b3a17.svg";
export { ForwardRef as ReactComponent };